export const PensionTypeEnum = Object.freeze({
    PP: "PP",
    DPS: "DPS",
    DSS: "DSS",
    DDS: "DDS",
});
